import { graphql, commitMutation } from 'react-relay';
import { types } from '../utils/constants';

const mutation = graphql`
    mutation RenderPortfolioEmailsMutation($input: RenderPortfolioEmailsInput!) {
        renderPortfolioEmails(input: $input) {
            clientMutationId
        }
    }
`;

const commit = (environment, args) => {
    const {
        message,
        portfolioItemIds,
        portfolioIds,
        recipientEmails,
        showNotes,
        senderEmail,
        senderName,
        shareType,
        userId,
        onCompleted,
        onError,
    } = args;

    let input = { message, recipientEmails, senderEmail, senderName, shareType, userId };

    if (shareType === types.FOLDERS) {
        input = { ...input, portfolioIds };
    } else if (shareType === types.ITEMS) {
        input = { ...input, portfolioItemIds, showNotes };
    }

    commitMutation(environment, {
        mutation,
        variables: {
            input,
        },
        onCompleted,
        onError,
    });
};

export default { commit };
